module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Oy9Z"))).then(() => parcelRequire('d0iPb'));